import React from "react"
import Typed from "react-typed"
import featuresData from "../../data/pageSections/home/features"
import Section from "./Section"
import Container from "./Container"
import ContainerNoPadding from "./ContainerNoPadding"
import { brandAccentColor } from "../../theme"
import H2 from "../typography/H2"
import P from "../typography/P"
import FeatureCard from "../layoutComponents/featuresCard"
import "react-typed/dist/animatedCursor.css"

const Features = () => (
  <Section className="padding-b-0">
    <H2>
      How does MindMe help you...{" "}
      {/* <Typed
        strings={[
          "capture more leads?",
          "convert more customers?",
          "get and stay organized?",
          "engage for better results?",
        ]}
        typeSpeed={40}
        backSpeed={50}
        loop
      >
        <span style={{ color: brandAccentColor }}></span>
      </Typed> */}
    </H2>
    <ContainerNoPadding tight>
      <P style={{ fontSize: "22px", textAlign: "center" }}>
        MindMe combines CRM, lead capture, email and text campaigns, landing
        pages, calendar & scheduling, sales pipelines, digital offers,
        automation and payments in a single, easy-to-use solution. Get more done
        with MindMe.
      </P>
    </ContainerNoPadding>
    <Container alignItems="stretch">
      {featuresData.map(({ icon, title, description, link }) => (
        <FeatureCard
          icon={icon}
          title={title}
          description={description}
          link={link}
          outline={brandAccentColor}
        />
      ))}
    </Container>
  </Section>
)

export default Features
